export default {
      id: "icon-pin-usage",
      viewBox: "0 0 24 24",
      url: "/" + "assets/sprite.svg#icon-pin",
      toString: function () {
        return this.url;
      }
    }